export class SanitizerPipeline {
    constructor(context) {
        this.sanitizers = [];
        this.context = context;
    }
    addSanitizer(sanitizer) {
        this.sanitizers.push(sanitizer);
        return this;
    }
    sanitize(text) {
        let result = text;
        for (const sanitizer of this.sanitizers) {
            result = sanitizer.sanitize(result);
        }
        return result;
    }
    getAllEntityMaps() {
        return this.context.getAllMaps();
    }
    updateConfig(config) {
        for (const sanitizer of this.sanitizers) {
            if (sanitizer.configKey in config) {
                sanitizer.setEnabled(config[sanitizer.configKey]);
            }
        }
    }
    getContext() {
        return this.context;
    }
    /**
     * Returns the list of sanitizers in the pipeline.
     * Useful for accessing individual sanitizers to modify their settings.
     */
    getSanitizers() {
        return this.sanitizers;
    }
}
